import * as React from "react";
import * as styles from "./SiteOffers.module.scss";
import Container from "react-bootstrap/Container";

export const StyledContainer: React.FC<any> = (props) => {
  return (
    <Container fluid className={`pt-5 pb-5 mb-5  ${styles.styledContainer}`}>
      {props.children}
    </Container>
  );
};

export const Subtitle: React.FC<any> = (props) => {
  return <div className={styles.subTitle}>{props.children}</div>;
};
